import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _construct from "@babel/runtime/helpers/construct";
import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
export var Preset = /*#__PURE__*/function () {
  function Preset() {
    _classCallCheck(this, Preset);
    for (var _len = arguments.length, more = new Array(_len), _key = 0; _key < _len; _key++) {
      more[_key] = arguments[_key];
    }
    this.data = [].concat(more) || [];
  }
  _createClass(Preset, [{
    key: "add",
    value: function add(nextOrTuple) {
      var newPreset = _construct(Preset, [nextOrTuple].concat(_toConsumableArray(this.data)));
      // TODO: remove this `this.data.push`,
      // once refactoring `create-plugins-list` to address this complexity:
      /**
       * preset.add(x)
       * preset.add(y)
       * preset.add(z)
       */
      // to:
      /**
       * immutablePreset = preset.add(x).add(foo).add(bar)
       * presetWithY = presetWithY.add(y)
       * presetWithZ = preset.add(z)
       */
      this.data.push(nextOrTuple);
      return newPreset;
    }
  }, {
    key: "has",
    value: function has(plugin) {
      return this.data.some(function (pluginPreset) {
        if (Array.isArray(pluginPreset)) {
          return pluginPreset[0] === plugin;
        }
        return pluginPreset === plugin;
      });
    }
  }, {
    key: "getEditorPlugins",
    value: function getEditorPlugins(excludes) {
      var editorPlugins = this.processEditorPlugins();
      return this.removeExcludedPlugins(editorPlugins, excludes);
    }
  }, {
    key: "processEditorPlugins",
    value: function processEditorPlugins() {
      var cache = new Map();
      this.data.forEach(function (pluginEntry) {
        if (Array.isArray(pluginEntry)) {
          var _pluginEntry = _slicedToArray(pluginEntry, 2),
            fn = _pluginEntry[0],
            options = _pluginEntry[1];
          cache.set(fn, options);
        } else {
          /**
           * Prevent usage of same plugin twice without override.
           * [
           *  plugin1,
           *  [plugin1, { option1: value }],
           *  plugin1, // This will throw
           * ]
           */
          if (cache.has(pluginEntry) && cache.get(pluginEntry) === undefined) {
            throw new Error("".concat(pluginEntry, " is already included!"));
          }
          cache.set(pluginEntry, undefined);
        }
      });
      var plugins = [];
      cache.forEach(function (options, fn) {
        plugins.push(fn(options));
      });
      if (plugins.some(function (plugin) {
        return typeof plugin === 'function';
      })) {
        throw new Error("!!! NextEditorPluginWithDependencies detected in presets. That's an unsupported runtime use case right now.");
      }
      return plugins;
    }
  }, {
    key: "removeExcludedPlugins",
    value: function removeExcludedPlugins(plugins, excludes) {
      if (excludes) {
        return plugins.filter(function (plugin) {
          return !plugin || !excludes.has(plugin.name);
        });
      }
      return plugins;
    }
  }]);
  return Preset;
}();